<template>
  <div id="daily-costs">
    <div class="row">
      <div class="col-md-6">
        <div class="box">
          <div class="box-title">Estimate Daily Cost</div>
          <div class="box-content">
            <div class="e-form mb-2">
              <ul class="circle red" v-if="errors.length > 0">
                <li v-for="(error, index) in errors" :key="index">
                  {{ error }}
                </li>
              </ul>
              <el-form inline size="mini">
                <el-form-item>
                  <el-select v-model="dailyCost.hub_id">
                    <el-option
                      v-for="hub in hubs"
                      :value="hub.id"
                      :label="hub.name"
                      :key="hub.id"
                    >
                      {{ hub.name }}
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-date-picker
                    size="mini"
                    v-model="dailyCost.issue_date"
                    type="date"
                    :value-format="'yyyy-MM-dd'"
                    placeholder="Issue Date"
                  />
                </el-form-item>
                <el-form-item class="w-20">
                  <el-input
                    type="number"
                    v-model="dailyCost.fixed"
                    placeholder="Fixed Cost"
                  />
                </el-form-item>
                <el-form-item>
                  <el-button @click="saveDailyCost" type="primary"
                    >Save</el-button
                  >
                </el-form-item>
              </el-form>
            </div>
            <table class="gray">
              <tbody>
                <slot v-for="(items, name) in groupBy(dailyCosts, 'name')">
                  <tr :key="name">
                    <th colspan="3" class="text-left">
                      {{ name }}
                    </th>
                  </tr>
                  <tr v-for="(item, ii) in items" :key="name + ii">
                    <td>{{ item.issue_date }}</td>
                    <td>{{ parseFloat(item.fixed) | toCurrency }}</td>
                    <td>
                      <a @click="editDailyCost(item)" class="fas fa-edit"></a>
                      <a
                        @click="deleteDailyCost(item.id)"
                        class="fas fa-trash-alt"
                      ></a>
                    </td>
                  </tr>
                </slot>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="box">
          <div class="box-title">Acct. Only Cost</div>
          <div class="box-content">
            <div class="e-form mb-2">
              <el-form inline size="mini">
                <el-form-item>
                  <el-date-picker
                    size="mini"
                    v-model="filter.from"
                    type="date"
                    :value-format="'yyyy-MM-dd'"
                    placeholder="Invoice From"
                  />
                </el-form-item>
                <el-form-item>
                  <el-date-picker
                    size="mini"
                    v-model="filter.to"
                    type="date"
                    :value-format="'yyyy-MM-dd'"
                    placeholder="To"
                  />
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="acctOnlyCost">
                    Analyse
                  </el-button>
                </el-form-item>
              </el-form>
            </div>
            <div v-if="!isEmptyData(realCosts)">
              <table
                class="gray data-grid"
                data-filter="true"
                data-export="CSV"
                style="max-height: calc(100vh - 185px)"
              >
                <thead>
                  <tr>
                    <th width="60" data-hoz="center">PVT</th>
                    <th>Company</th>
                    <th data-type="number" width="80">Months</th>
                    <th data-type="number" data-sort="desc" width="80"
                      >Total</th
                    >
                    <th data-type="number" width="120">Monthly</th>
                    <th data-type="number" width="120">Daily</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in realCosts" :key="i">
                    <td>
                      <a
                        v-if="getCompany(row.company_id).private"
                        class="fas fa-check-circle"
                      />
                      <span class="hidden">{{
                        getCompany(row.company_id).private
                      }}</span>
                    </td>
                    <td>{{ getCompany(row.company_id).name }}</td>
                    <td>{{ row.months }}</td>
                    <td class="number">{{ row.amount | toCurrency }}</td>
                    <td class="number">{{ row.monthly | toCurrency }}</td>
                    <td class="number">{{ row.daily | toCurrency }}</td>
                  </tr>
                </tbody>
              </table>
              <div class="tabulator-footer">
                <div class="tabulator-footer-contents flex-space align-center">
                  <div>&nbsp;</div>
                  <div class="flex-start align-center">
                    <div class="tag fs13"
                      >Total:
                      {{ sumArray(targetValues("amount")) | toCurrency }}</div
                    >
                    <div class="tag fs13"
                      >Monthly:
                      {{ sumArray(targetValues("monthly")) | toCurrency }}</div
                    >
                    <div class="tag fs13"
                      >Daily:
                      {{ sumArray(targetValues("daily")) | toCurrency }}</div
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DataGrid from "../../controllers/data_grid";

export default {
  data() {
    return {
      filter: {
        from: null,
        to: null,
      },
      dailyCost: {},
      dailyCosts: [],
      realCosts: [],
      companies: [],
      hubs: [],
      errors: [],
    };
  },
  created() {
    this.loadDailyCosts();
    this.acctOnlyCost();
  },
  computed: {
    getCompany() {
      return function (id) {
        return this.companies.find((o) => o.id == id) || {};
      };
    },
    targetValues() {
      return function (name) {
        return this.realCosts.filter((o) => !o.excl).map((o) => o[name]);
      };
    },
  },
  methods: {
    loadDailyCosts() {
      this.errors = [];
      delete this.dailyCost.issue_date;
      delete this.dailyCost.fixed;
      this.$http
        .get("/api/v1/daily_costs.json")
        .then((response) => {
          this.dailyCosts = response.data;
        })
        .catch((err) => {});

      this.$http
        .get("/api/v1/hubs.json")
        .then((response) => {
          this.hubs = response.data;
          if (this.hubs[0]) this.dailyCost.hub_id = this.hubs[0].id;
        })
        .catch((err) => {});
    },
    groupBy(collection, identity) {
      return this._.groupBy(collection, identity);
    },
    editDailyCost(item) {
      this.dailyCost = Object.assign({}, item);
    },
    saveDailyCost() {
      if (this.dailyCost.id > 0) {
        this.$http
          .put(`/api/v1/daily_costs/${this.dailyCost.id}`, {
            daily_cost: this.dailyCost,
          })
          .then((response) => {
            this.loadDailyCosts();
          })
          .catch((err) => {
            this.errors = err.response.data.errors;
          });
      } else {
        this.$http
          .post(`/api/v1/daily_costs`, { daily_cost: this.dailyCost })
          .then((response) => {
            this.loadDailyCosts();
          })
          .catch((err) => {
            this.errors = err.response.data.errors;
          });
      }
    },
    deleteDailyCost(id) {
      this.$http
        .delete(`/api/v1/daily_costs/${id}`)
        .then((response) => {
          let index = this.dailyCosts.findIndex((obj) => obj.id === id);
          if (index >= 0) this.dailyCosts.splice(index, 1);
        })
        .catch((err) => {});
    },
    acctOnlyCost() {
      this.realCosts = [];
      this.$http
        .get("/api/v1/financials/performance", {
          params: Object.assign({}, this.filter, { type: "third_party_cost" }),
        })
        .then((response) => {
          const data = response.data;
          this.filter.from = data.dates.from;
          this.filter.to = data.dates.to;
          this.realCosts = data.invoices;
          this.companies = data.companies;
          setTimeout(() => DataGrid.init(), 250);
        })
        .catch((err) => {});
    },
  },
};
</script>
